// src/store/resetAction.ts
export const resetApp = () => ({ type: 'APP/RESET' } as const);
export type ResetAppAction = ReturnType<typeof resetApp>;
